import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { AppPipesModule } from '../app-pipes/app-pipes.module';
import { EditEmployeeUserComponent } from '../../pages/users/edit-employee-user/edit-employee-user.component';
import { EmployeeProfilePictureComponent } from '../../pages/users/edit-employee-user/employee-profile-picture/employee-profile-picture.component';

@NgModule({
  imports: [CommonModule, SharedModule, AppPipesModule],
  exports: [EditEmployeeUserComponent, EmployeeProfilePictureComponent],
  declarations: [EditEmployeeUserComponent, EmployeeProfilePictureComponent]
})
export class UsersModule {}
